import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function RemoveCodeGroupDialog({
  open,
  linkedRuleUnits = [],
  onConfirm,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Code Group is linked to one or more active rules. Do you want to
          continue?
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Rule Tab</TableCell>
              <TableCell>Rule Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {linkedRuleUnits.map((ruleUnit) => (
              <TableRow key={ruleUnit.ruleUnitKey || ruleUnit.ruleUnitName}>
                <TableCell>{ruleUnit.ruleTab || ""}</TableCell>
                <TableCell>{ruleUnit.ruleUnitName || ""}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>No</Button>
        <Button onClick={onConfirm} variant="contained">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
